import { Injectable } from '@angular/core';
import { IonContent } from '@ionic/angular';

@Injectable({ providedIn: 'root' })
export class AnimationService {
  private static ionContent?: IonContent;

  public static registerIonContent(content: IonContent) {
    this.ionContent = content;
  }

  public static scrollToTop() {
    if (this.ionContent) {
      this.ionContent.scrollToTop(300);
    } else {
      window.scrollTo({ 
        top: 0, 
        left: 0, 
        behavior: 'smooth' 
      });
    }
  }
}